// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__1JN7E","textContainer":"Banner_textContainer__LymNK"};